<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
</style>
<style lang="less" scoped>
.zzl-inspect-status-row {
  margin-bottom: 10px;
}
.zzl-inspect-status-label {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  margin-right: 4px;
}
.zzl-inspect-status-btns /deep/ .ivu-btn {
  padding-left: 10px;
  padding-right: 10px;
}
.zzl-inspect-count {
  display: inline-block;
  min-width: 18px;
  margin-left: 4px;
  padding: 0 5px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  color: #64748b;
  text-align: center;
  background: rgba(148, 163, 184, 0.2);
  border-radius: 8px;
}
.zzl-inspect-status-btns /deep/ .ivu-btn-primary .zzl-inspect-count {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.25);
}
.zzl-inspect-range-mode {
  padding: 2px 8px;
  margin-left: 4px;
  font-size: 12px;
  color: #64748b;
  background: rgba(241, 245, 249, 0.9);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 6px;
}
.zzl-inspect-clean-block {
  margin-bottom: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--border, #e2e8f0);
}
.zzl-inspect-clean-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  margin-bottom: 8px;
}
.zzl-inspect-clean-label {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}
.zzl-inspect-topbar-left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.zzl-inspect-presets /deep/ .ivu-btn {
  margin-right: 0;
}
.zzl-inspect-topbar-label {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}
.zzl-inspect-toolbar-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.zzl-inspect-toolbar-label-col {
  flex: 0 0 40px;
  width: 40px;
  text-align: left;
}
.zzl-inspect-toolbar-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.zzl-inspect-clean-split {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 12px;
}
.zzl-inspect-clean-tools {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.zzl-inspect-clean-action {
  flex-shrink: 0;
}
.zzl-inspect-executor-row {
  align-items: center;
}
.zzl-inspect-executor-select {
  flex: 1;
  min-width: 220px;
  max-width: 480px;
}
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="height:auto;min-height:50px;padding:8px 10px;background:linear-gradient(to right,#fff,var(--border));flex-wrap:wrap;gap:8px;">
      <div class="zzl-inspect-topbar-left">
        <div class="zzl-inspect-toolbar-row">
          <span
            class="zzl-inspect-topbar-label zzl-inspect-toolbar-label-col"
          >平台</span>
          <div class="zzl-inspect-toolbar-main split5">
            <ButtonGroup size="small">
              <Button
                :type="platform === 'pmis' ? 'primary' : 'default'"
                @click="setPlatform('pmis')"
              >
                项管
              </Button>
              <Button
                :type="platform === 'jlis' ? 'primary' : 'default'"
                @click="setPlatform('jlis')"
              >
                监理
              </Button>
            </ButtonGroup>
            <span class="zzl-inspect-topbar-label">项目</span>
            <Select
              v-model="project_id"
              filterable
              style="width:300px"
              placeholder="选择项目"
              @on-change="onProjectChange"
            >
              <OptionGroup
                v-for="g in groupedProjectsForSelect"
                :key="g.key"
                :label="g.name"
              >
                <Option
                  v-for="pr in g.projects"
                  :key="pr.id"
                  :value="pr.id"
                  :label="pr.name"
                >
                  {{ pr.name }}
                  <Tag>{{ pr.finished ? '已完成' : '进行中' }}</Tag>
                </Option>
              </OptionGroup>
            </Select>
            <Button
              type="text"
              size="small"
              title="刷新项目列表"
              style="padding:4px 6px;margin-left:2px;"
              @click="getProjects"
            >
              <Icon type="ios-refresh" size="20" />
            </Button>
            <span class="zzl-inspect-topbar-label">时间段</span>
            <BaseDate
              v-model="rangeStart"
              placeholder="起始"
              style="width:140px;"
              @on-change="onManualRangeChange"
            />
            <span style="color:#94a3b8;">—</span>
            <BaseDate
              v-model="rangeEnd"
              placeholder="截止"
              style="width:140px;"
              @on-change="onManualRangeChange"
            />
            <span class="zzl-inspect-range-mode">
              <span style="opacity:0.85;">
                {{ rangeByDue ? '按截止日期' : '按完成日期' }}
              </span>
            </span>
            <i-switch
              v-model="rangeByDue"
              size="small"
              @on-change="onRangeByDueChange"
            />
          </div>
        </div>
        <div class="zzl-inspect-toolbar-row zzl-inspect-presets">
          <span
            class="zzl-inspect-topbar-label zzl-inspect-toolbar-label-col"
          >快捷</span>
          <div class="zzl-inspect-toolbar-main" style="gap:6px;">
            <ButtonGroup size="small">
              <Button
                :type="quickPresetKind === 'week' ? 'primary' : 'default'"
                @click="setQuickPresetKind('week')"
              >
                周
              </Button>
              <Button
                :type="quickPresetKind === 'month' ? 'primary' : 'default'"
                @click="setQuickPresetKind('month')"
              >
                月
              </Button>
              <Button
                :type="quickPresetKind === 'quarter' ? 'primary' : 'default'"
                @click="setQuickPresetKind('quarter')"
              >
                季度
              </Button>
              <Button
                :type="quickPresetKind === 'half' ? 'primary' : 'default'"
                @click="setQuickPresetKind('half')"
              >
                半年度
              </Button>
            </ButtonGroup>
            <Select
              v-model="quickPresetYear"
              size="small"
              style="width:88px"
              placeholder="年"
              @on-change="onQuickPresetYearChange"
            >
              <Option
                v-for="y in quickPresetYearOptions"
                :key="y"
                :value="y"
              >{{ y }}</Option>
            </Select>
            <Button
              type="default"
              size="small"
              title="上一段"
              style="padding:0 8px;"
              @click="shiftQuickPreset(-1)"
            >
              <Icon type="ios-arrow-back" />
            </Button>
            <Button
              v-for="btn in quickPresetPeriodButtons"
              :key="btn.key"
              size="small"
              :type="isQuickPeriodActive(btn) ? 'primary' : 'dashed'"
              @click="applyQuickPeriod(btn)"
            >
              {{ btn.label }}
            </Button>
            <Button
              type="default"
              size="small"
              title="下一段"
              style="padding:0 8px;"
              @click="shiftQuickPreset(1)"
            >
              <Icon type="ios-arrow-forward" />
            </Button>
          </div>
        </div>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="dataLoading" fix size="large">
          <div class="zzl-view-data-loading-text">加载数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:10px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">
              数据下载和清理
            </div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" icon="md-download" :disabled="!project_id" :loading="dataLoading" @click="getData">
                获取数据
              </Button>
              <Button type="warning" icon="md-copy" @click="CopyToClip">复制数据</Button>
            </div>
          </div>

          <div class="zzl-inspect-status-row flex-wrap" style="align-items:center;gap:8px;">
            <span class="zzl-inspect-status-label">任务状态</span>
            <ButtonGroup size="small" class="zzl-inspect-status-btns">
              <Button
                :type="statusFilters.length === 0 ? 'primary' : 'default'"
                @click="selectAllStatuses"
              >
                所有
                <span class="zzl-inspect-count">{{ fetchedTasks.length }}</span>
              </Button>
              <Button
                v-for="s in inspectStatusOptions"
                :key="s"
                :type="statusFilters.includes(s) ? 'primary' : 'default'"
                @click="toggleStatusFilter(s)"
              >
                {{ s }}
                <span class="zzl-inspect-count">{{ inspectStatusCounts[s] }}</span>
              </Button>
            </ButtonGroup>
          </div>

          <div class="zzl-inspect-status-row flex-wrap zzl-inspect-executor-row" style="align-items:center;gap:8px;margin-bottom:10px;">
            <span class="zzl-inspect-status-label">负责人员</span>
            <Select
              v-model="executorFilters"
              multiple
              filterable
              size="small"
              clearable
              placeholder="全部负责人（数量随上方任务状态变化）"
              :max-tag-count="4"
              class="zzl-inspect-executor-select"
              @on-change="onExecutorFiltersChange"
            >
              <Option
                v-for="ex in executorNamesSorted"
                :key="ex"
                :value="ex"
                :label="executorOptionLabel(ex)"
              >
                {{ executorOptionLabel(ex) }}
              </Option>
            </Select>
          </div>

          <div class="zzl-inspect-clean-block">
            <template v-if="!hideTrackingRecords">
              <div class="zzl-inspect-clean-split">
                <div class="zzl-inspect-clean-tools">
                  <div class="zzl-inspect-clean-row" style="margin-bottom:0;">
                    <span class="zzl-inspect-clean-label">跟踪记录</span>
                    <div class="flex-wrap" style="align-items:center;gap:6px;">
                      <span style="font-size:12px;color:var(--subtext2);">隐藏</span>
                      <i-switch
                        v-model="hideTrackingRecords"
                        size="small"
                        @on-change="onHideTrackingChange"
                      />
                    </div>
                    <div class="flex-wrap" style="align-items:center;gap:6px;">
                      <span style="font-size:12px;color:var(--subtext2);">最近</span>
                      <i-switch
                        v-model="onlyLatestTracking"
                        size="small"
                        @on-change="onOnlyLatestTrackingChange"
                      />
                    </div>
                    <template v-if="!onlyLatestTracking">
                      <BaseDate
                        v-model="tracking_startDate"
                        placeholder="开始日期"
                        size="small"
                        style="width:140px;"
                      />
                      <BaseDate
                        v-model="tracking_endDate"
                        placeholder="结束日期"
                        size="small"
                        style="width:140px;"
                      />
                    </template>
                  </div>
                  <div class="zzl-inspect-clean-row" style="margin-bottom:0;">
                    <span class="zzl-inspect-clean-label">深度清理</span>
                    <div class="flex-wrap" style="align-items:center;gap:6px;">
                      <i-switch v-model="extractForm" size="small" @on-change="cleanData" />
                      <span style="font-size:12px;">提取表格</span>
                    </div>
                    <div class="flex-wrap" style="align-items:center;gap:6px;">
                      <i-switch v-model="onlyQuestion" size="small" @on-change="cleanData" />
                      <span style="font-size:12px;">隐藏合规项</span>
                    </div>
                  </div>
                </div>
                <div class="zzl-inspect-clean-action">
                  <Button type="primary" icon="md-color-wand" @click="cleanData">数据清理</Button>
                </div>
              </div>
            </template>
            <div
              v-else
              class="flex-wrap flex-between"
              style="align-items:center;margin-bottom:0;width:100%;"
            >
              <div class="zzl-inspect-clean-row" style="margin-bottom:0;">
                <span class="zzl-inspect-clean-label">跟踪记录</span>
                <div class="flex-wrap" style="align-items:center;gap:6px;">
                  <span style="font-size:12px;color:var(--subtext2);">隐藏</span>
                  <i-switch
                    v-model="hideTrackingRecords"
                    size="small"
                    @on-change="onHideTrackingChange"
                  />
                </div>
              </div>
              <Button type="primary" icon="md-color-wand" @click="cleanData">数据清理</Button>
            </div>
          </div>

          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="6"
              placeholder="选择项目并获取数据后，将按筛选与清洗规则生成文本"
            />
          </div>
          <div style="font-size:12px;color:var(--subtext2);margin-top:8px;">
            字符数：{{ aiText.length }}
          </div>
        </div>

        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="zzl-inspect"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('zzl-inspect') }} · zzl-inspect）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button v-if="images.length" icon="md-images" @click="copyImageAddresses">复制图片地址</Button>
            <Button icon="md-copy" @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button icon="md-download" @click="exportPDF" :disabled="!result">导出 PDF</Button>
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import {deepCleanTask, renderEFormMap, extractAttachments} from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import {ButtonGroup} from 'view-design';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';
import {
  classifyInspectTask,
  INSPECT_STATUS_OPTIONS,
  taskKeepLatestTrackingOnly,
} from '@/components/ai/zzl/inspect-task-helpers.js';

/**
 * 将任意时刻对齐到「周 / 月 / 季度 / 半年」区间的起始。
 * @param {import('moment').Moment} m 输入时刻
 * @param {'week'|'month'|'quarter'|'half'} kind 粒度
 * @returns {import('moment').Moment} 区间起点
 */
function snapStartToKind(m, kind) {
  m = moment(m).clone();
  if (!m.isValid()) {
    return moment().startOf('month');
  }
  if (kind === 'week') {
    return m.startOf('isoWeek');
  }
  if (kind === 'month') {
    return m.startOf('month');
  }
  if (kind === 'quarter') {
    const q = Math.floor(m.month() / 3);
    return m.month(q * 3).startOf('month');
  }
  if (kind === 'half') {
    return m.month(m.month() < 6 ? 0 : 6).startOf('month');
  }
  return m.startOf('month');
}

/**
 * 某粒度下，包含 refStart 的整段起止时间（含时分秒，供接口与 BaseDate）。
 * @param {'week'|'month'|'quarter'|'half'} kind 粒度
 * @param {import('moment').Moment|string} refStart 参考时刻
 * @returns {{rangeStart: string, rangeEnd: string}} 起止字符串
 */
function rangeForPeriodAt(kind, refStart) {
  const start = snapStartToKind(moment(refStart), kind);
  let end;
  if (kind === 'week') {
    end = start.clone().endOf('isoWeek');
  } else if (kind === 'month') {
    end = start.clone().endOf('month');
  } else if (kind === 'quarter') {
    end = start.clone().add(2, 'months').endOf('month');
  } else if (kind === 'half') {
    end = start.clone().add(5, 'months').endOf('month');
  } else {
    end = start.clone().endOf('month');
  }
  return {
    rangeStart: start.format('YYYY-MM-DD HH:mm:ss'),
    rangeEnd: end.format('YYYY-MM-DD HH:mm:ss'),
  };
}

/**
 * 快捷按钮展示文案。
 * @param {'week'|'month'|'quarter'|'half'} kind 粒度
 * @param {import('moment').Moment|string} start 区间起点
 * @returns {string} 展示用标签
 */
function labelForPeriod(kind, start) {
  const s = moment(start);
  if (kind === 'week') {
    return `${s.format('YYYY')}-W${String(s.isoWeek()).padStart(2, '0')}`;
  }
  if (kind === 'month') {
    return `${s.year()}-${s.month() + 1}`;
  }
  if (kind === 'quarter') {
    return `${s.year()}-Q${Math.floor(s.month() / 3) + 1}`;
  }
  if (kind === 'half') {
    return `${s.year()}-${s.month() < 6 ? '上' : '下'}半年`;
  }
  return s.format('YYYY-M');
}

export default {
  components: {ButtonGroup, AiPromptPanel, AiMarkdownStreamPanel},
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    const yStart = moment().startOf('year').format('YYYY-MM-DD HH:mm:ss');
    const yEnd = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    return {
      pageStateKey: 'ai_zzl_inspect',
      pageStateFields: [
        'project_id',
        'rangeStart',
        'rangeEnd',
        'rangeByDue',
        'platform',
        'statusFilters',
        'executorFilters',
        'hideTrackingRecords',
        'onlyLatestTracking',
        'extractForm',
        'onlyQuestion',
        'tracking_startDate',
        'tracking_endDate',
        'userText',
        'quickPresetKind',
        'quickPresetYear',
        'quickRefIso',
      ],
      project_id: null,
      projects: [],
      /** 接口返回的原始任务列表 */
      fetchedTasks: [],
      rangeStart: yStart,
      rangeEnd: yEnd,
      /** true=按截止日期拉数(due=1)，false=按完成日期(due=0) */
      rangeByDue: false,
      /** pmis=项管(项目管理) jlis=监理 */
      platform: 'pmis',
      /** 多选；空数组表示不按状态过滤；「所有」对应空数组 */
      statusFilters: [],
      /** 负责人 executorName 多选；空数组表示不按负责人过滤 */
      executorFilters: [],
      /** true=输出中不包含任何跟踪记录（仅任务基本信息）；关闭后可配置最近/日期/深度清理 */
      hideTrackingRecords: true,
      /** 默认仅保留每条任务最近一条跟踪 */
      onlyLatestTracking: true,
      extractForm: false,
      onlyQuestion: false,
      tracking_startDate: null,
      tracking_endDate: null,
      aiText: '',
      images: [],
      files: [],
      userText: '请根据以下「工作检查」任务数据，从进度、风险、闭环与跟踪质量等维度做归纳分析，并给出可执行建议。',
      ai_executings: false,
      result: '',
      dataLoading: false,
      inspectStatusOptions: INSPECT_STATUS_OPTIONS,
      /** 快捷：周 / month / quarter / half */
      quickPresetKind: 'month',
      quickPresetYear: moment().year(),
      /** 快捷条锚点（ISO），用于前后翻与 6 段按钮 */
      quickRefIso: null,
    };
  },
  computed: {
    workingTaskCount() {
      return this.buildWorkingTasks().length;
    },
    inspectStatusCounts() {
      const map = {};
      this.inspectStatusOptions.forEach((s) => {
        map[s] = 0;
      });
      (this.fetchedTasks || []).forEach((t) => {
        const k = classifyInspectTask(t);
        if (Object.prototype.hasOwnProperty.call(map, k)) {
          map[k]++;
        }
      });
      return map;
    },
    /**
     * 快捷条锚点：有 quickRefIso 用其；否则用「当前时间 + 类型」对齐。
     * @returns {import('moment').Moment} 对齐后的锚点
     */
    quickPresetRefMoment() {
      if (this.quickRefIso) {
        const m = moment(this.quickRefIso);
        if (m.isValid()) {
          return snapStartToKind(m, this.quickPresetKind);
        }
      }
      return snapStartToKind(moment(), this.quickPresetKind);
    },
    quickPresetYearOptions() {
      const y = moment().year();
      const arr = [];
      for (let i = y - 5; i <= y + 5; i++) {
        arr.push(i);
      }
      return arr;
    },
    /**
     * 当前锚点往前 3、往后 2 共 6 个时间段按钮数据。
     * @return {Array<{key: string, label: string, rangeStart: string, rangeEnd: string}>}
     */
    quickPresetPeriodButtons() {
      const kind = this.quickPresetKind;
      const ref = this.quickPresetRefMoment;
      const list = [];
      for (let i = -3; i <= 2; i++) {
        let m = moment(ref);
        if (kind === 'week') {
          m.add(i, 'weeks');
        } else if (kind === 'month') {
          m.add(i, 'months');
        } else if (kind === 'quarter') {
          m.add(i * 3, 'months');
        } else if (kind === 'half') {
          m.add(i * 6, 'months');
        }
        m = snapStartToKind(m, kind);
        const {rangeStart, rangeEnd} = rangeForPeriodAt(kind, m);
        list.push({
          key: `${kind}-${rangeStart}`,
          label: labelForPeriod(kind, m),
          rangeStart,
          rangeEnd,
        });
      }
      return list;
    },
    /** 当前平台下的项目（与 daily 一致：platform 可为逗号分隔多值） */
    filteredProjects() {
      const key = this.platform;
      return (this.projects || []).filter((p) => {
        if (!p || p.platform == null || p.platform === '') {
          return false;
        }
        const parts = String(p.platform).split(',').map((s) => s.trim()).filter(Boolean);
        return parts.includes(key);
      });
    },
    /** 按 group 分组供 Select OptionGroup */
    groupedProjectsForSelect() {
      const groupmap = {};
      this.filteredProjects.forEach((p) => {
        const group = (p.group && String(p.group).trim()) || '未分组';
        if (!groupmap[group]) {
          groupmap[group] = [];
        }
        groupmap[group].push(p);
      });
      return Object.keys(groupmap)
          .sort((a, b) => a.localeCompare(b, 'zh-CN'))
          .map((g) => ({
            key: g,
            name: g,
            projects: groupmap[g],
          }));
    },
    /** 仅应用任务状态筛选后的任务列表（供负责人统计与选项） */
    tasksAfterStatusFilter() {
      let tasks = (this.fetchedTasks || []).map((t) => t);
      if (this.statusFilters && this.statusFilters.length) {
        const set = new Set(this.statusFilters);
        tasks = tasks.filter((t) => set.has(classifyInspectTask(t)));
      }
      return tasks;
    },
    /** 负责人 -> 人数（在任务状态筛选后的集合上统计） */
    executorOptionCounts() {
      const map = {};
      this.tasksAfterStatusFilter.forEach((t) => {
        const k = this.executorNameKey(t);
        map[k] = (map[k] || 0) + 1;
      });
      return map;
    },
    /** 负责人选项排序列表 */
    executorNamesSorted() {
      return Object.keys(this.executorOptionCounts).sort((a, b) =>
        a.localeCompare(b, 'zh-CN'),
      );
    },
  },
  mounted() {
    this.ensureDefaultRange();
    this.$api.afterLogin(() => {
      this.getProjects();
    });
  },
  methods: {
    ensureDefaultRange() {
      if (!this.rangeStart) {
        this.rangeStart = moment().startOf('year').format('YYYY-MM-DD HH:mm:ss');
      }
      if (!this.rangeEnd) {
        this.rangeEnd = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
    },
    labelForMod,
    executorNameKey(task) {
      const n = task && task.executorName;
      if (n == null || String(n).trim() === '') {
        return '未指定';
      }
      return String(n).trim();
    },
    executorOptionLabel(ex) {
      const n = this.executorOptionCounts[ex] || 0;
      return `${ex}（${n}）`;
    },
    pruneExecutorFilters() {
      const valid = new Set(Object.keys(this.executorOptionCounts));
      const prev = this.executorFilters || [];
      const next = prev.filter((ex) => valid.has(ex));
      if (next.length !== prev.length) {
        this.executorFilters = next;
      }
    },
    buildWorkingTasks() {
      let tasks = this.tasksAfterStatusFilter.map((t) => t);
      if (this.executorFilters && this.executorFilters.length) {
        const exSet = new Set(this.executorFilters);
        tasks = tasks.filter((t) => exSet.has(this.executorNameKey(t)));
      }
      if (this.onlyLatestTracking && !this.hideTrackingRecords) {
        tasks = tasks.map((t) => taskKeepLatestTrackingOnly(t));
      }
      return tasks;
    },
    zzlReportPdfStem() {
      const p = this.filteredProjects.find((x) => x.id === this.project_id) ||
          this.projects.find((x) => x.id === this.project_id);
      const name = p ? p.name.replace(/[/\\?%*:|"<>]/g, '_') : 'inspect';
      return `${name}_工作检查_${moment().format('YYYYMMDD')}`;
    },
    getProjects() {
      this.$api.get('logined_zzl/projects').then((res) => {
        this.projects = res.data.data || [];
        this.ensureProjectSelection();
      });
    },
    /** 当前选中项目需在 filteredProjects 内 */
    ensureProjectSelection() {
      const list = this.filteredProjects;
      const ok = list.some((p) => p.id === this.project_id);
      if (!this.project_id || !ok) {
        this.project_id = list.length ? list[0].id : null;
      }
    },
    setPlatform(p) {
      if (this.platform === p) {
        return;
      }
      this.platform = p;
      this.fetchedTasks = [];
      this.aiText = '';
      this.__savePageState();
      this.ensureProjectSelection();
    },
    onProjectChange() {
      this.fetchedTasks = [];
      this.aiText = '';
      this.__savePageState();
    },
    onRangeByDueChange() {
      this.__savePageState();
    },
    setQuickPresetKind(kind) {
      if (this.quickPresetKind === kind) {
        return;
      }
      const base = this.quickRefIso ? moment(this.quickRefIso) : moment();
      this.quickPresetKind = kind;
      this.quickRefIso = snapStartToKind(base, kind).toISOString();
      this.quickPresetYear = moment(this.quickRefIso).year();
      this.__savePageState();
    },
    onQuickPresetYearChange() {
      const m = moment(this.quickPresetRefMoment).year(this.quickPresetYear);
      this.quickRefIso = snapStartToKind(m, this.quickPresetKind).toISOString();
      this.__savePageState();
    },
    /**
     * 沿当前快捷锚点平移一档（与 6 段按钮同一锚点规则）。
     * @param {number} dir -1 向前，1 向后
     */
    shiftQuickPreset(dir) {
      const m = moment(this.quickPresetRefMoment).clone();
      const kind = this.quickPresetKind;
      if (kind === 'week') {
        m.add(dir, 'weeks');
      } else if (kind === 'month') {
        m.add(dir, 'months');
      } else if (kind === 'quarter') {
        m.add(dir * 3, 'months');
      } else if (kind === 'half') {
        m.add(dir * 6, 'months');
      }
      this.quickRefIso = snapStartToKind(m, kind).toISOString();
      this.quickPresetYear = moment(this.quickRefIso).year();
      this.__savePageState();
    },
    applyQuickPeriod(btn) {
      this.rangeStart = btn.rangeStart;
      this.rangeEnd = btn.rangeEnd;
      this.quickRefIso = moment(btn.rangeStart).toISOString();
      this.quickPresetYear = moment(btn.rangeStart).year();
      this.__savePageState();
    },
    isQuickPeriodActive(btn) {
      const a = moment(this.rangeStart);
      const b = moment(btn.rangeStart);
      if (!a.isValid() || !b.isValid()) {
        return false;
      }
      return a.isSame(b, 'day');
    },
    onManualRangeChange() {
      const m = moment(this.rangeStart);
      if (!m.isValid()) {
        return;
      }
      this.quickRefIso = snapStartToKind(m, this.quickPresetKind).toISOString();
      this.quickPresetYear = m.year();
      this.__savePageState();
    },
    /**
     * 后端：按完成时间区间拉取任务（参数名可按接口实际调整）
     */
    getData() {
      if (!this.project_id) {
        this.Error('请选择项目');
        return;
      }
      this.ensureDefaultRange();
      this.dataLoading = true;
      this.$api
          .post('logined_zzl/get_task_by_finish_time', {
            pid: this.project_id,
            startDate: moment(this.rangeStart).format('YYYY-MM-DD'),
            endDate: moment(this.rangeEnd).format('YYYY-MM-DD'),
            due: this.rangeByDue ? 1 : 0,
            platform: this.platform,
          })
          .then((res) => {
            this.fetchedTasks = res.data.data || [];
            this.pruneExecutorFilters();
            this.cleanData();
          })
          .catch((e) => {
            console.error(e);
            this.Error(e && e.message ? e.message : '获取任务数据失败');
          })
          .finally(() => {
            this.dataLoading = false;
          });
    },
    onHideTrackingChange() {
      this.__savePageState();
      if (this.fetchedTasks.length) {
        this.cleanData();
      }
    },
    onOnlyLatestTrackingChange() {
      if (this.fetchedTasks.length) {
        this.cleanData();
      }
    },
    selectAllStatuses() {
      this.statusFilters = [];
      this.pruneExecutorFilters();
      if (this.fetchedTasks.length) {
        this.cleanData();
      }
    },
    toggleStatusFilter(s) {
      const arr = this.statusFilters || [];
      const i = arr.indexOf(s);
      if (i >= 0) {
        arr.splice(i, 1);
      } else {
        arr.push(s);
      }
      this.pruneExecutorFilters();
      if (this.fetchedTasks.length) {
        this.cleanData();
      }
    },
    onExecutorFiltersChange() {
      this.__savePageState();
      if (this.fetchedTasks.length) {
        this.cleanData();
      }
    },
    cleanData() {
      this.__savePageState();
      this.images = [];
      this.files = [];
      const tasks = this.buildWorkingTasks();
      const eformmap = {};
      const statusPart =
        this.statusFilters && this.statusFilters.length ?
          `（状态：${this.statusFilters.join('、')}）` :
          '';
      const execPart =
        this.executorFilters && this.executorFilters.length ?
          `（负责人：${this.executorFilters.join('、')}）` :
          '';
      const hideTrackPart = this.hideTrackingRecords ?
        '（已隐藏全部跟踪记录）' :
        '';
      const trackPart = this.onlyLatestTracking && !this.hideTrackingRecords ?
        '（已精简为每条任务最近一条跟踪）' :
        '';
      const n = (this.fetchedTasks || []).length;
      const head =
        `# 工作检查\n# 原始任务数：${n}，当前展示：${tasks.length}` +
        `${statusPart}${execPart}${hideTrackPart}${trackPart}\n\n`;
      if (!tasks.length) {
        this.aiText = head + '（无符合当前筛选条件的任务，请调整筛选或重新获取数据）';
        return;
      }
      const blocks = tasks.map((t) =>
        deepCleanTask(
            t,
            this.tracking_startDate,
            this.tracking_endDate,
            null,
          this.extractForm ? eformmap : null,
          this.onlyQuestion,
          false,
          this.hideTrackingRecords,
        ),
      );
      let body = blocks.join('\n\n---\n\n');
      if (this.extractForm) {
        body += renderEFormMap(eformmap);
      }
      this.aiText = head + body;
      const {images, files, text} = extractAttachments(this.aiText);
      this.images = images;
      this.files = files;
      this.aiText = text;
    },
    async CopyToClip() {
      const text = this.aiText || '';
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          if (!document.execCommand('copy')) {
            throw new Error('copy failed');
          }
          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
      } catch (err) {
        console.error(err);
        this.Error('复制失败');
      }
    },
  },
};
</script>
